export default __webpack_public_path__ + "static/media/download.aaa4472f.svg";